/**
 * Salesforce Service
 */

import client from '../client';

const listing = async(params)=>{
    let res:any = await client.get("/admin/users/list",params);
    return res;
}
const remove = async(params)=>{
    let res:any = await client.post("/admin/users/remove",params);
    return res;
}
const activate = async(params)=>{
    let res:any = await client.post("/admin/users/activate",params);
    return res;
}
const get = async(params)=>{
    let res:any = await client.get("/admin/users/get",params);
    return res;
}


const update = async(params)=>{
    let res:any = await client.post("/admin/users/update",params);
    return res;
}


const create = async(params)=>{
    let res:any = await client.post("/admin/users/create",params);
    return res;
}

export default {
    listing,remove,activate,get,update,create
}